import { Box, Button, Typography } from '@mui/material'
import standalone from '../../../icons/standalone.png'
import ConfigureStepper from './ConfigureStepper';
import AlertComponent from './AlertComponent';
import { useRedundancy } from './hooks';

const boxStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 200,
  height: 150,
  backgroundColor: 'var(--card)',
  boxShadow: 3,
  borderRadius: 4,
  flexDirection: "column"
};

const Redundancy = () => {
  const { openDialog, setOpenDialog, handleAddRedundancyClick } = useRedundancy()

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: "100%",
          height: '100%',
          flexDirection: 'column',
        }}
      >
        {/* <AlertComponent header={'Standby server is disconnected'} paragraph={'Data is not syncing'}/> */}
        {/* Standalone Box */}
        <Box
          id="standalone-box"
          sx={{
            ...boxStyles,
          }}
        >
          <img src={standalone} alt="Standalone" style={{ width: "2rem", height: "2rem" }} />
          <Typography sx={{ mt: 1, color: 'var(--foreground)' }}>Standalone</Typography>
          <Typography sx={{ color: 'var(--foreground)' }}>{window.location.hostname}</Typography>
        </Box>

        <Box
          sx={{
            width: 0,
            height: 50,
            borderLeft: '3px dashed var(--muted-foreground)',
          }}
        />

        {/* Add Redundancy Box */}
        <Box
          id="add-redundancy-box"
          sx={{
            ...boxStyles,
          }}
        >
          <Button variant="contained" onClick={handleAddRedundancyClick} sx={{ width: "10rem", height: "2rem", fontSize: "x-small" }}>
            Add Redundancy
          </Button>
        </Box>
      </Box>

      {/* ConfigureStepper Dialog */}
      <ConfigureStepper open={openDialog} handleClose={() => setOpenDialog(false)} />
    </>
  )
}

export default Redundancy;
